<template>
    <form-panel v-if="model" :title="$t('labels.meal_option_groups')">
        <entity-select-input
            v-if="model.restaurant"
            v-model="model.groups"
            label="labels.meal_option_groups"
            name="meal_option_groups"
            :entity="selectApiClientType.MEAL_OPTION_GROUP"
            :data-vv-as="$t('labels.meal_option_groups')"
            :error-messages="errors.collect('meal_option_groups')"
            :query-params="{ restaurant: model.restaurant }"
            multi-select
            @input="onGroupsChange"
        ></entity-select-input>
        <checkbox-input
            v-model="needCustomOrder"
            :disabled="!customGroupOrderEnabled"
            label="labels.custom_option_groups_order"
            name="customOrder"
        ></checkbox-input>
        <v-list v-if="needCustomOrder">
            <draggable
                v-model="model.groupsOrder"
                handle=".handle"
                @end="onDragEnd"
            >
                <v-list-item
                    v-for="(item, index) in model.groupsOrder"
                    :key="item.id"
                    class="c-pointer show-item-on-hover"
                >
                    <v-list-item-title class="handle">
                        <v-icon> drag_indicator</v-icon>
                        {{ index + 1 + '. ' + groupName(item.id) }}
                    </v-list-item-title>
                </v-list-item>
            </draggable>
        </v-list>
    </form-panel>
</template>
<script>
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput.vue'
import CheckboxInput from '@/components/form/Inputs/CheckboxInput.vue'
import FormPanel from '@/components/form/FormPanel.vue'
import Draggable from 'vuedraggable'
import selectapiType from '@/store/type/selectapiType'
import selectApiClientType from '@/api/SelectApiClientType'
import IdFromIri from '@/services/IdFromIri'

export default {
    components: { FormPanel, CheckboxInput, Draggable, EntitySelectInput },
    props: {
        value: Object,
    },

    data() {
        return {
            optionGroupNames: [],
            needCustomOrder: false,
        }
    },

    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        selectApiClientType() {
            return selectApiClientType
        },
        customGroupOrderEnabled() {
            return this.model.groups !== null && this.model.groups?.length > 1
        },
    },

    watch: {
        needCustomOrder() {
            if (this.needCustomOrder) {
                this.fillGroupsOrder()
            } else {
                this.model.groupsOrder = null
            }
        },
    },

    mounted() {
        this.model = this.value
        this.needCustomOrder = !!this.model.groupsOrder

        this.$store
            .dispatch(
                selectapiType.getActionName(
                    this.selectApiClientType.MEAL_OPTION_GROUP,
                    selectapiType.actions.LOAD
                ),
                { query: { restaurant: this.model.restaurant } }
            )
            .then((res) => {
                this.optionGroupNames = res
            })
    },

    methods: {
        normalizePositions() {
            if (!this.model.groupsOrder || !this.model.groupsOrder.length)
                return

            const startsFromZero = this.model.groupsOrder.some(
                (el) => el.position === 0
            )
            if (!startsFromZero) return

            this.model.groupsOrder.forEach((el) => {
                el.position = el.position + 1
            })
            this.model = { ...this.model }
        },
        onDragEnd() {
            this.model.groupsOrder.forEach((el, i) => {
                el.position = i + 1
            })
            this.model = { ...this.model }
        },
        onGroupsChange() {
            if (this.model.groups.length < 2) {
                this.model.groupsOrder = null
                this.needCustomOrder = false
            }
            this.fillGroupsOrder()
        },
        fillGroupsOrder() {
            const currentState = this.model.groupsOrder || []
            const values = this.model.groups.map((iri, index) => {
                const id = parseInt(IdFromIri.getId(iri))

                const currentIndex = currentState.findIndex((x) => x.id === id)

                return {
                    id,
                    position: currentIndex > -1 ? currentIndex : index + 1,
                }
            })

            this.model.groupsOrder = values
            this.model = { ...this.model }
            this.normalizePositions()
        },
        groupName(id) {
            return this.optionGroupNames.find((x) => x.id === id)?.label
        },
    },
}
</script>
